export const getters = {
    list: state => state.list,
};
